<template>
  <div class="answer--review">
    <!-- 未审核的样式 -->
    <el-button v-if="inPassOf(['10', '30'])"
               :disabled="disabled"
               size="small"
               type="success"
               plain
               @click="onReview(true)">通过
    </el-button>
    <!-- 已通过的样式 -->
    <el-button v-if="inPassOf(['20'])"
               :disabled="disabled"
               size="small"
               type="success">通过
    </el-button>
    <!-- 未审核的样式 -->
    <el-button v-if="inPassOf(['10', '20'])"
               :disabled="disabled"
               size="small"
               type="danger"
               plain
               @click="onReview(false)">不通过
    </el-button>
    <!-- 未通过的样式 -->
    <el-button v-if="inPassOf(['30'])"
               :disabled="disabled"
               size="small"
               type="danger"
               @click="onReview(false)">不通过
    </el-button>
    <!-- 错误信息 -->
    <span class="answer-error-message">{{answer.errorMessage}}</span>
  </div>
</template>

<script>
import QuestionReview from '../../question-review.js'
import ReviewBox from '../../components/ReviewBox'

export default {
  components: {},
  mixins: [],
  props: {
    id: String,
    answer: Object,
    disabled: Boolean,
    errorMessages: Array,
    orderid: String,
    status: String,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  beforeCreate () {

  },
  created () {
    this.$nextTick(() => {})
  },
  mounted () {
  },
  methods: {
    ...Vuex.mapActions([]),
    onReview (passed) {
      // 检查工单状态
      this.checkOrderStatus()
      // 验证题目答案
      if (QuestionReview().validateAnswer(this.id)) {
        if (passed) {
          // 审核通过
          QuestionReview().reviewPassed(this.id)
        } else {
          if (this.status !== '4') {
            this.$alert('审单通过工单不允许改变题目通过状态', '提示', {
              confirmButtonText: '确定',
            })
          } else {
            // 审核不通过
            let extendedStepsStart = QuestionReview().getExtendedStepsStart()
            if (extendedStepsStart > 0 && QuestionReview().getIndexe(this.id).index() >= extendedStepsStart) {
              // 结束题号后选不通过退单 不行
              let errorMessage = `强制用户结束答题第${extendedStepsStart}题后必须通过`
              this.$alert(errorMessage, '提示', {type: 'error'})
            } else {
              ReviewBox.questionNotPassed({
                callback: (errorMessage) => {
                  errorMessage && QuestionReview().reviewNotPassed(this.id, errorMessage)
                },
                messages: this.errorMessages,
              })
            }
          }
        }
      } else {
        this.$message.error('答案内容错误, 请查正！')
      }
    },
    inPassOf (array) {
      return array.indexOf(this.answer.isPassed) !== -1
    },
    async checkOrderStatus () {
      const {data: status} = await request.alert('checkOrderStatus', {id: this.orderid})
      if (this.status !== String(status)) {
        this.$alert('当前工单状态已改变，请刷新页面查看。', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    }
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionReviewButton/index.vue